<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Name, Email"
              aria-label="Name, Email"
              aria-describedby="Name, Email"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getEmployees(1)">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="employees"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Name</th>
          <th class="text-center">Email</th>
          <th class="text-center">Last Updated</th>
          <th class="text-center">Platforms</th>
          <th class="text-center">Status</th>
          <th class="text-center">Actions</th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.email}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.last_updated}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.platform}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 0">Inactive</span>
                <span class="name mb-0 text-sm text-success" v-if="row.status == 1">Active</span>
              </div>
            </div>
          </td>
          <td class="text-center">
            <base-dropdown class="dropdown" position="right">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" @click="getEmployee(row.id)">View</a>
                <a
                  class="dropdown-item"
                  @click="getEmployeeStatus(row.id, row.status)"
                >Update Status</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>

    <div class="row" id="div-edit-admin-profile">
      <div class="col-md-4">
        <modal
          :show.sync="modals.admin_profile_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">CANDIDATE PROFILE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="row">
                    <div class="media align-items-center" slot="title">
                      <span class="avatar avatar-lg rounded-circle">
                        <img
                          alt="Image placeholder"
                          class="custom-height"
                          v-bind:src="candidate_profile.profile_picture"
                        />
                      </span>
                    </div>
                    <div class="media-body ml-2 d-none d-lg-block col-lg-12">
                      <span>Full Name: {{ candidate_profile.full_name }}</span>
                      <br />
                      <span>Current Position (years): {{ candidate_profile.current_position_years }}</span>
                      <br />
                      <span>Current Company Name: {{ candidate_profile.current_company_name }}</span>
                    </div>
                  </div>
                  <hr class="my-4" />
                  <div>
                    <tabs fill class="flex-column flex-md-row">
                      <card shadow>
                        <tab-pane title="Info">
                          <span slot="title">Info</span>

                          <div class="row">
                            <div class="col-sm-3">Nationality:</div>
                            <div class="col-sm-9">{{ candidate_profile.nationality }}</div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Gender:</div>
                            <div class="col-sm-9">{{ candidate_profile.gender }}</div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Contact No.:</div>
                            <div class="col-sm-9">{{ candidate_profile.contact_number }}</div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Email Address:</div>
                            <div class="col-sm-9">{{ candidate_profile.email_address }}</div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Address:</div>
                            <div class="col-sm-9">{{ candidate_profile.address }}</div>
                          </div>

                          <hr class="my-4" />

                          <span style="font-weight: bold;">Education</span>
                          <br />
                          <br />

                          <div v-for="(item, index) in candidate_profile.education">
                            <div class="row">
                              <div class="col-sm-6">{{ item.date }}</div>
                              <div class="col-sm-6">
                                {{ item.institute }}
                                <br />
                                {{ item.qualification }}
                                <br />
                                {{ item.major }}
                              </div>
                            </div>

                            <hr class="my-4" />
                          </div>

                          <span style="font-weight: bold;">Experience</span>
                          <br />
                          <br />

                          <div v-for="(item, index) in candidate_profile.experience">
                            <div class="row">
                              <div class="col-sm-6">{{ item.date }}</div>
                              <div class="col-sm-6">{{ item.job_title }} ({{ item.company }})</div>
                            </div>

                            <!--<div class="row">
                                                  <div class="col-sm-6">Specialization: </div>
                                                  <div class="col-sm-6">-</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Industry: </div>
                                                  <div class="col-sm-6">-</div>
                            </div>-->

                            <div class="row">
                              <div class="col-sm-6">Position Level:</div>
                              <div class="col-sm-6">{{ item.position_level.value }}</div>
                            </div>

                            <div class="row">
                              <div class="col-sm-6">Experience Description:</div>
                              <div class="col-sm-6">{{ item.working_description }}</div>
                            </div>

                            <hr class="my-4" />
                          </div>

                          <span style="font-weight: bold;">Skills</span>
                          <br />
                          <br />

                          <div class="row">
                            <div class="col-sm-3">Skills:</div>
                            <div class="col-sm-9">{{ candidate_profile.skills }}</div>
                          </div>
                        </tab-pane>

                        <!-- <tab-pane title="Education">
                                              <span slot="title">
                                                  Education
                                              </span>

                                              <div v-for="(item, index) in candidate_profile.education">
                                                <div class="row">
                                                  <div class="col-sm-6">{{ item.date }}</div>
                                                  <div class="col-sm-6">{{ item.institute }}<br />{{ item.qualification }}<br />{{ item.major }}</div>
                                                </div>

                                                <hr class="my-4" />
                                              </div>

                        </tab-pane>-->

                        <!-- <tab-pane title="Experience">
                                              <span slot="title">
                                                  Experience
                                              </span>

                                              <div v-for="(item, index) in candidate_profile.experience">
                                                <div class="row">
                                                  <div class="col-sm-6">{{ item.date }}</div>
                                                  <div class="col-sm-6">{{ item.job_title }} ({{ item.company }})</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Specialization: </div>
                                                  <div class="col-sm-6">-</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Industry: </div>
                                                  <div class="col-sm-6">-</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Position Level: </div>
                                                  <div class="col-sm-6">{{ item.position_level.value }}</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Experience Description: </div>
                                                  <div class="col-sm-6">{{ item.working_description }}</div>
                                                </div>

                                                <hr class="my-4" />
                                              </div>
                                              
                        </tab-pane>-->

                        <!-- <tab-pane title="Skills">
                                              <div class="row">
                                                <div class="col-sm-3">Skills: </div>
                                                <div class="col-sm-9">{{ candidate_profile.skills }}</div>
                                              </div>
                        </tab-pane>-->

                        <tab-pane title="Additional">
                          <span slot="title">Additional</span>

                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div
                              class="col-sm-9"
                              style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
                              v-if="candidate_profile.resume != ''"
                            >
                              <a
                                :href="candidate_profile.resume"
                                rel="noopener noreferrer"
                                target="_blank"
                              >{{ candidate_profile.resume }}</a>
                            </div>
                            <div class="col-sm-9" v-else>-</div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div
                              class="col-sm-9"
                            >{{ candidate_profile.currency }} {{ candidate_profile.expected_salary }}</div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9">
                              <li v-for="language in candidate_profile.languages" :key="language.id">
                                {{ language.language.value }}: Speak({{ language.spoken_rating }}), Write({{ language.written_rating }})
                              </li>
                            </div>
                          </div>
                        </tab-pane>
                      </card>
                    </tabs>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.admin_profile_modal = false"
                    >Cancel</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div class="row" id="div-update-status-modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.update_status_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">UPDATE STATUS</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Status:</label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="updateStatus.status">
                        <option value>-- Select Status --</option>
                        <option value="0" :selected="updateStatus.status == 0">Not Active</option>
                        <option value="1" :selected="updateStatus.status == 1">Active</option>
                      </select>
                    </div>
                  </div>

                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.update_status_modal = false; update = false;"
                    >Cancel</base-button>
                    <base-button type="success" class="my-4" @click="updateCandidateStatus()">Update</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalEmployees" :value="pageNumber"></base-pagination>
    </div>
  </div>
</template>
<script>
import EventBus from "./../../event-bus";

export default {
  name: "employees-table",
  props: {
    type: {
      type: String
    },
    title: String,
    status: String
  },
  data() {
    return {
      search_text: "",
      candidate_profile_id: 0,
      modals: {
        admin_profile_modal: false,
        update_status_modal: false
      },
      totalEmployees: 0,
      updateStatus: {
        candidate_profile_id: 0,
        status: 0
      },
      candidate_profile: {
        full_name: "",
        current_position_years: "",
        current_company_name: "",
        nationality: "",
        gender: "",
        contact_number: "",
        email_address: "",
        address: "",
        education: [],
        experience: [],
        skills: "",
        resume: "",
        expected_salary: "",
        languages: [],
        profile_picture: "",
        currency: ""
      }
    };
  },
  computed: {
    employees() {
      return this.$store.getters.employees;
    },
    pageNumber() {
      return parseInt(this.$route.query.page);
    },
    totalEmployee() {
      return this.totalEmployees;
    }
  },
  watch: {
    pageNumber() {
      this.getEmployees(this.$route.query.page);
    },
    status: function() {
      this.$router.push({ query: { page: 1 } });
      this.getEmployees(this.$route.query.page);
      this.getTotalEmployees();
    }
  },
  mounted() {
    this.getEmployees(1);
    this.getTotalEmployees();
  },
  methods: {
    getEmployees: function(page_number) {
      this.$store
        .dispatch("fetchEmployees", { keyword: this.search_text, page: page_number, status: this.status })
        .then(response => {
          const { data, meta } = response.data;
          this.$router.push({ query: { page: page_number } });
          this.totalEmployees = meta.total_result;
          this.$store.dispatch("updateState", {
            key: "employees",
            value: data
          });
        });
    },

    getEmployee: function(user_id) {
      this.modals.admin_profile_modal = true;
      this.$store
        .dispatch("fetchEmployee", {
          candidate_profile_id: user_id
        })
        .then(response => {
          this.candidate_profile.full_name = response.data.full_name;
          this.candidate_profile.current_position_years =
            response.data.current_position_years == null ||
            response.data.current_position_years == "-"
              ? "-"
              : parseFloat(response.data.current_position_years).toFixed(1);
          this.candidate_profile.current_company_name =
            response.data.current_company_name == ""
              ? "-"
              : response.data.current_company_name;
          this.candidate_profile.nationality = response.data.nationality;
          this.candidate_profile.gender = response.data.gender;
          this.candidate_profile.contact_number = response.data.contact_number;
          this.candidate_profile.email_address = response.data.email_address;
          this.candidate_profile.address = response.data.address;
          this.candidate_profile.education = response.data.education;
          this.candidate_profile.experience = response.data.experience;
          this.candidate_profile.skills = response.data.skills;
          this.candidate_profile.expected_salary =
            response.data.expected_salary;
          this.candidate_profile.profile_picture =
            response.data.profile_picture == ""
              ? "img/theme/team-4-800x800.jpg"
              : response.data.profile_picture;
          this.candidate_profile.currency = response.data.currency;
          this.candidate_profile.resume = response.data.resume;
          this.candidate_profile.languages = response.data.languages;
        });
    },

    getTotalEmployees() {
      this.$store
        .dispatch("fetchTotalEmployee", { status: this.status })
        .then(response => {
          let responseData = response.data;
          this.totalEmployees = responseData;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getEmployeeStatus: function(user_id, status) {
      this.modals.update_status_modal = true;
      this.updateStatus.status = status;
      this.updateStatus.candidate_profile_id = user_id;
    },

    updateCandidateStatus: function(user_id) {
      this.$store
        .dispatch("updateCandidateStatus", {
          candidate_profile_id: this.updateStatus.candidate_profile_id,
          status: this.updateStatus.status
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.modals.update_status_modal = false;
            this.getEmployees(this.$route.query.page);
            EventBus.$emit("updateEmployeeCount");
          }
        });
    }
  }
};
</script>
<style>
.custom-height {
  height: 100%;
}
</style>
